/**
 * Created by hp on 2017/8/4.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import logo from '../../images/logo.png';
import config from '../../config'

class MainInitComponent extends Component {
    constructor() {
        super();
        this.handleInitSlide = this.handleInitSlide.bind(this);
    }

    handleInitSlide() {
        const {banners} = this.props;

        // init WKSlide
        let content = banners.map((item) => {
            return {id: item.object_id, url: item.url, image: item.image, type: item.banner_type};
        });
        this.props.dispatch({
            type: 'WK_INIT_SLIDE',
            payload: {content},
        });
    }

    componentDidUpdate() {
        this.handleInitSlide();
    }

    componentDidMount() {

        this.handleInitSlide();

        // init share
        this.props.dispatch({
            type: 'UPDATE_SHARE_DATA',
            payload: {
                title: "最好用的微课平台，首创PPT语音同步、视频语音交互，一分钟创建课程。与三千万伙伴一同享受成长的快乐。只有一种稳赚不赔的投资，就是学习",
                desc: "最好用的微课平台，首创PPT语音同步、视频语音交互，一分钟创建课程。与三千万伙伴一同享受成长的快乐。只有一种稳赚不赔的投资，就是学习",
                imgUrl: logo,
                link: config.MAIN_URL,
            }
        });

        this.props.dispatch({
            type: 'WK_INIT_BOTTOM_BAR',
            payload: {
                selectType: 'main',
            }
        });
    }

    render() {
        return null;
    }
}

export default connect((state) => ({
    banners: state.main.banners.data.ret,
}))(MainInitComponent);



// WEBPACK FOOTER //
// ./src/components/main/MainInitComponent.js